'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

var _connectUpgradeData = require('ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData');

var _connectUpgradeData2 = _interopRequireDefault(_connectUpgradeData);

var _ProductActivationButton = require('ui-addon-upgrades/_core/productActivation/ProductActivationButton');

var _ProductActivationButton2 = _interopRequireDefault(_ProductActivationButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRODUCT_ACTIVATION = _sources.sourceKeys.PRODUCT_ACTIVATION;
exports.default = (0, _connectUpgradeData2.default)(_ProductActivationButton2.default, PRODUCT_ACTIVATION);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/button/UIProductActivationButton.js
// module id = 619
// module chunks = 3 4